import React, { useRef } from 'react'
import { Link } from 'react-router-dom'
import IconButtonUI from '../../widgets/action/IconButtonUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import LabelAndValueUI from '../../widgets/layout/LabelAndValueUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import './FinAppHomePage.css'

const FinAppHomePageUI = ({ context, bankAccountList, loanBankBalance,
  onRefreshClick, messageList, errorList}) =>
    <PrivatePageSF context={context} className='pg_f_home'
    centered={!bankAccountList && !loanBankBalance && !errorList}
    >
      {
        !bankAccountList && !loanBankBalance && !errorList && /* !context.account && */
        <SpinnerComponentUI />
      }
      {
        errorList && errorList.length > 0 &&
        <GenericErrorUI error={errorList[0]} />
      }
      {
        context.account && bankAccountList && loanBankBalance &&
        <div className='g_flex_h g_flex_center'>
          <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
          <b className='g_m_left_50'>{context.account.accountName}, {context.account.state}</b>
        </div>
      }
      {
        bankAccountList &&
        <>
          <div className='g_m_top_50'>
            <table className='g_center'><tbody>
              <tr className='g_muted g_small'>
                <td align='center'>Bank A/C no</td><td></td>
                <td align='center'>IFSC code</td><td></td>
                <td align='center'>Balance</td><td></td>
                <td align='center'>Pending</td><td></td>
                <td align='center'>Available</td>
              </tr>
              {
                bankAccountList.map((bankAccount, i) =>
                  <tr key={i}>
                    <td>{bankAccount.bankAccountNumber}</td><td></td>
                    <td>{bankAccount.ifscCode}</td><td></td>
                    <td align='right'>{bankAccount.currentBalanceF1}</td><td></td>
                    <td align='right'>{bankAccount.pendingBalanceF1}</td><td></td>
                    <td align='right'>{bankAccount.availableBalanceF1}</td>
                  </tr>
                )
              }
            </tbody></table>
          </div>

          {
            loanBankBalance && loanBankBalance.availableBalanceF1 &&
            <table className='g_center g_m_top_100'><tbody>
              <tr>
                <td align='right'>Loan Disbursed</td>
                <td align='right'>{loanBankBalance.disbursedTotalF1}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td align='right'>Available Bank Balance</td>
                <td></td>
                <td align='right'>{loanBankBalance.availableBalanceF1}</td>
                <td></td>
              </tr>
              <tr>
                <td align='right'>Use of Proceeds</td>
                <td align='right'><span className='g_muted g_small g_m_left_100'>Total</span>
                  <span className='g_m_left_50'>{loanBankBalance.useOfProceedsTotalF1}</span></td>
                <td align='right'><span className='g_muted g_small g_m_left_100'>Unpaid</span>
                  <span className='g_m_left_50'>{loanBankBalance.useOfProceedsUnpaidF1}</span></td>
                <td align='right'><span className='g_muted g_small g_m_left_100'>Paid</span>
                  <span className='g_m_left_50'>{loanBankBalance.useOfProceedsPaidF1}</span></td>
              </tr>
              <tr>
                <td align='right'>Next EMI Payment</td>
                <td align='right'></td>
                <td align='right'>{loanBankBalance.nextEMITotalF1}</td>
                <td></td>
              </tr>
              <tr>
                <td align='right'>DSRA</td>
                <td></td>
                <td align='right'><span className='g_muted g_small g_m_left_100'>Total</span>
                  <span className='g_m_left_50'>{loanBankBalance.dsraTotalF1}</span></td>
                <td align='right'><span className='g_muted g_small g_m_left_100'>Current</span>
                  <span className='g_m_left_50'>{loanBankBalance.dsraCurrent >= 0 ? loanBankBalance.dsraCurrentF1 : `(${loanBankBalance.dsraCurrentF1})`}</span></td>
              </tr>
              <tr>
                <td align='right'><b>Excess Bank Balance</b></td>
                <td></td>
                <td align='right'><b>{loanBankBalance.excessBalance >= 0 ? loanBankBalance.excessBalanceF1 : `(${loanBankBalance.excessBalanceF1})`}</b></td>
                <td></td>
              </tr>
            </tbody></table>
          }

          <div className='tiles g_center g_m_top_100'>
            <Link to='/vendors'>Vendors</Link>
            <Link to='/vendorBills'>Vendor Bills</Link>
            {
              bankAccountList && bankAccountList.length &&
              <Link to={`/txns2/${bankAccountList[0].bankAccountNumber}`}>Transactions</Link>
            }
            <Link to='/loans'>Loans</Link>
            <Link to='/customers'>Customers</Link>
            <Link to='/projects'>Projects</Link>

            {/*
              bankAccountList && bankAccountList.length &&
              <Link to={`/txns/${bankAccountList[0].bankAccountNumber}`}>Txns (Zybra)</Link>
            */}

          {/*
            <Link to='/orders'>Purchase Orders</Link>
            <Link to='/budgets'>Budgets</Link>
            <Link to='/cards'>Cards</Link>
            <Link to='/invoices'>Invoices</Link>
          */}
          </div>
        </>
      }
    </PrivatePageSF>

export default FinAppHomePageUI
